// extracted by mini-css-extract-plugin
export var wordContainer = "_n8-0";